import api from "@/config/api";
import type { RequestOptions } from "@/shared/types/api.types";
import { API_ENDPOINTS } from "@/constants/api-endpoints";
import type { PageResponseDTO } from "@/shared/types/pagination.types";
import type {
  ProductRequestDTO,
  ProductResponseDTO,
  ProductSearchParams,
} from "../types/product.types";

export const productService = {
  create: async (data: ProductRequestDTO): Promise<ProductResponseDTO> => {
    const response = await api.post<ProductResponseDTO>(
      API_ENDPOINTS.PRODUCTS.BASE,
      data,
    );
    return response.data;
  },

  list: async (
    params?: ProductSearchParams,
    options?: RequestOptions,
  ): Promise<PageResponseDTO<ProductResponseDTO>> => {
    const response = await api.get<PageResponseDTO<ProductResponseDTO>>(
      API_ENDPOINTS.PRODUCTS.SEARCH,
      { params, signal: options?.signal },
    );
    return response.data;
  },

  searchUser: async (
    params?: ProductSearchParams,
    options?: RequestOptions,
  ): Promise<PageResponseDTO<ProductResponseDTO>> => {
    const response = await api.get<PageResponseDTO<ProductResponseDTO>>(
      API_ENDPOINTS.PRODUCTS_USER.SEARCH,
      { params, signal: options?.signal },
    );
    return response.data;
  },

  getByIdUser: async (
    id: number,
    options?: RequestOptions,
  ): Promise<ProductResponseDTO> => {
    const response = await api.get<ProductResponseDTO>(
      API_ENDPOINTS.PRODUCTS_USER.BY_ID(id),
      { signal: options?.signal },
    );
    return response.data;
  },

  getById: async (
    id: number,
    options?: RequestOptions,
  ): Promise<ProductResponseDTO> => {
    const response = await api.get<ProductResponseDTO>(
      API_ENDPOINTS.PRODUCTS.BY_ID(id),
      { signal: options?.signal },
    );
    return response.data;
  },

  update: async (
    id: number,
    data: ProductRequestDTO,
  ): Promise<ProductResponseDTO> => {
    const response = await api.put<ProductResponseDTO>(
      API_ENDPOINTS.PRODUCTS.BY_ID(id),
      data,
    );
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(API_ENDPOINTS.PRODUCTS.BY_ID(id));
  },
};
